import type {
  GenericHttpRequestOptions,
  GenericHttpResponse,
  HttpMethod,
} from '@iconik-io/core/src/http/generic_http_transport';

import type { ProgressEvent } from './client';

export class GenericRetryError extends Error {}

export type ShouldRetry = (response: GenericHttpResponse) => boolean;

export type GenericRetryOptions = {
  retries?: number;
  minTimeout?: number;
  maxTimeout?: number;

  method?: HttpMethod[];
  status?: number[];
  errorCodes?: string[];

  /**
   * Allows client applications to retry requests based on some custom criteria. Any error thrown
   * in this function will cause a retry and if max retry count has been reached this error will
   * propagate out to the client application.
   *
   * If the function returns true a retry will be performed until max retry count has been reached at
   * which point a GenericRetryError will be thrown.
   *
   * If the function returns false the request will fallback to checking method, status and
   * errorCodes to see if the request should be retried.
   *
   * @see GenericRetryError
   */
  shouldRetry?: ShouldRetry;
};

export type UploaderHttpRequestOptions = GenericHttpRequestOptions & {
  onUploadProgress?: (progress: ProgressEvent) => void;
  retryOptions?: GenericRetryOptions;
};
